<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b"><a id="page_vii"></a>Contents</h2>
<p class="tocfm"><a href="#/xhtml/ill#ill">List of Illustrations</a></p>
<p class="tocfm"><a href="#/xhtml/preface#preface">Preface and Acknowledgments</a></p>
<p class="tocfm"><a href="#/xhtml/abb#abb">Abbreviations and Acronyms</a></p>
<p class="tocchapb"><a href="#/xhtml/chapter0#chapter0">Introduction: Management and the Control of Research and Development</a></p>
<p class="tocchap"><a href="#/xhtml/chapter1#chapter1">1   Social and Technical Issues of Spaceflight</a></p>
<p class="tocchap"><a href="#/xhtml/chapter2#chapter2">2   Creating Concurrency</a></p>
<p class="tocchap"><span href="#/xhtml/chapter3#chapter3" title="Link target outside of Sample">3   From Concurrency to Systems Management</span></p>
<p class="tocchap"><span href="#/xhtml/chapter4#chapter4" title="Link target outside of Sample">4   JPL’s Journey from Missiles to Space</span></p>
<p class="tocchap"><span href="#/xhtml/chapter5#chapter5" title="Link target outside of Sample">5   Organizing the Manned Space Program</span></p>
<p class="tocchap"><span href="#/xhtml/chapter6#chapter6" title="Link target outside of Sample">6   Organizing ELDO for Failure</span></p>
<p class="tocchap"><span href="#/xhtml/chapter7#chapter7" title="Link target outside of Sample">7   ESRO’s American Bridge across the Management Gap</span></p>
<p class="tocchapt"><span href="#/xhtml/chapter8#chapter8" title="Link target outside of Sample">8   Coordination and Control of High-Tech Research and Development</span></p>
<p class="tocfm"><span href="#/xhtml/notes#notes" title="Link target outside of Sample">Notes</span></p>
<p class="tocfm"><span href="#/xhtml/essay#essay" title="Link target outside of Sample">Essay on Sources</span></p>
<p class="tocfm"><span href="#/xhtml/index#index" title="Link target outside of Sample">Index</span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?86954dae